export default "__VITE_ASSET__COCYc6JI__";